module.exports = __webpack_public_path__ + "img/icon-3.db4612ce.png";